import loadable from '@loadable/component';

export const LazyServiceCenter = loadable(() => import(/* webpackChunkName: "content/servicecenter" */ '.'));
